import React, { useEffect, useState } from 'react';
import { request } from 'utilities/graph';
import { getVideosByTypeByCreatedAt } from 'graphql/queries';
import NewVideoNotificationModal from './NewVideoNotificationModal';
import cache from 'utilities/cache';
import { NOTIFICATION_CATEGORIES } from '../constants/videoNotification';

export default function VideoNotificationChecker() {
  const [showNotification, setShowNotification] = useState(false);
  const [newestVideo, setNewestVideo] = useState(null);

  useEffect(() => {
    const checkForNewVideos = async () => {
      try {
        const { data: { getVideosByTypeByCreatedAt: { items: videos } } } = await request(getVideosByTypeByCreatedAt, {
          type: 'Video',
          limit: 1,
          sortDirection: 'DESC',
        });

        if (videos.length === 0) return;

        const latestVideo = videos[0];
        const lastNotifiedTime = cache.get('app:facility:notifiedNewestVideoTime');

        // 只有當 category 是 'new' 或 'update' 時才顯示通知
        const shouldShowNotification = NOTIFICATION_CATEGORIES.includes(latestVideo.category) &&
          (!lastNotifiedTime || new Date(latestVideo.createdAt) > new Date(lastNotifiedTime));

        if (shouldShowNotification) {
          setNewestVideo(latestVideo);
          setShowNotification(true);
        }
      } catch (error) {
        console.error('Error checking for new videos:', error);
      }
    };

    checkForNewVideos();
  }, []);

  const handleClose = () => {
    setShowNotification(false);
  };

  return (
    <NewVideoNotificationModal
      open={showNotification}
      onClose={handleClose}
      video={newestVideo}
    />
  );
}
